export const PAGE_TYPES = {
  MM_PAGE: "MM page",
  VARIANT_PAGE: "Variant listing page",
  GALLERY_PAGE: "Gallery page",
  SPECS_PAGE: "Specs page",
  PRICE_PAGE: "Price page",
  DIMENSIONS_PAGE: "Dimensions page",
  COLOURS_PAGE: "Colours page",
  HOME_PAGE: "Homepage",
  SEARCH_PAGE: "Search page",
  COMPARISON_PAGE: "Comparison page",
  MMV_PAGE: "MMV page",
  MILEAGE_PAGE: "Mileage page",
  BUY_HOMEPAGE: "Buy Homepage",
  COLLECTION_PAGE: "Collection page",
  REVIEW_PAGE: "Review page",
  IMAGE_PAGE: "Images page",
  FAQS_PAGE: "FAQs page",
  WISHLIST_PAGE: "Wishlist page",
  RATINGS_CALCULATION: "Ratings Calculation",
  ONBOARDING_PAGE: "Onboarding page",
  QUOTE_PAGE: "QuotePage",
  DEAL_CONFIRMATION_PAGE: "Deal Confirmation page",
  VARIANT_SELECTION_PAGE: "Variant Selection page",
  PAYMENT_SUCCESS_PAGE: "Payment Success page",
  BOOKING_CONFIRMATION_PAGE: "Booking Confirmation page",
} as const;

export type PageType = (typeof PAGE_TYPES)[keyof typeof PAGE_TYPES];
